import React from 'react';
import { useNavigate } from 'react-router-dom';
import PayoutRequestForm from '../components/PayoutRequestForm';
import BottomNav from '../BottomNav';
import './PayoutRequestPage.css';

const PayoutRequestPage = () => {
  const navigate = useNavigate();

  const handleRequestSubmitted = (requestId) => {
    // Navigate back to wallet with success message
    navigate('/wallet', { 
      state: { 
        message: `Payout request submitted successfully! Request ID: ${requestId}`,
        type: 'success'
      }
    });
  };

  return (
    <div className="payout-request-page">
      <div className="page-header">
        <button 
          className="back-button"
          onClick={() => navigate('/wallet')}
        >
          ← Back to Wallet
        </button>
        <div className="header-content">
          <h1>Request Payout</h1>
          <p>Withdraw your earnings to your bank account</p>
        </div>
      </div>

      <div className="page-content">
        <PayoutRequestForm onRequestSubmitted={handleRequestSubmitted} />
      </div>
      <BottomNav />
    </div>
  );
};

export default PayoutRequestPage;